// extracted by mini-css-extract-plugin
export default {"download":"DownloadPhotos-module--download--2da25","check":"DownloadPhotos-module--check--9eb0c"};